import React from "react";
import Footer from "./Footer";
import SmallContact from "./SmallContact";

function PageShell({ children }) {
  return (
    <>
      <main id="main-content">{children}</main>
      <Footer />
      <SmallContact />
    </>
  );
}

export default PageShell;
